import React from 'react';
import { TypographyHeading, Stacker, BusAndCarIcon, TypographyBody, FlexGrid } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
export function HotelBasketTransfer() {
    const { resourceStrings: { TRANSFER_INCLUSION_MESSAGE, NEXT_STEP }, } = useGlobalContext();
    return (React.createElement(FlexGrid, { container: true, disableEqualOverflow: true, alignItems: "flex-start", justifyContent: "space-between", flexWrap: "nowrap" },
        React.createElement(FlexGrid, null,
            React.createElement(Stacker, { flexDirection: "row", spacing: 3 },
                React.createElement(BusAndCarIcon, { size: "xs", va: "top" }),
                React.createElement(TypographyHeading, { size: "2xs", color: "text.body", component: "h4", mb: 1 }, TRANSFER_INCLUSION_MESSAGE))),
        React.createElement(TypographyBody, { size: "s", color: "grey.base" }, NEXT_STEP)));
}
